<template>
    <div>
        <a class="btn btn-primary" :href="speaker.form_embed_url" target="_blank"><slot>Make booking enquiry</slot></a>

        <!--
        <b-modal ref="buyModal" size="lg" :title="'Book a speaker'" :ok-only="true" ok-variant="link" ok-title="Close">
            <div style="min-height: 600px;">
                <iframe :src="speaker.form_embed_url" width="100%" height="700" frameborder="0" ></iframe>
            </div>
        </b-modal>
        -->
    </div>
</template>

<script>
export default {
    props: {
        speaker: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
        }
    },

    mounted() {
    },

    methods: {
        // Clicked to apply for a seat
        buyClick() {
            this.$refs['buyModal'].show('buyModal');
        },
    }
}
</script>
